module.exports = __webpack_public_path__ + "img/left-arrow-icon.96b587d6.svg";